export enum SettingsTabs {
  PROFILE = 'PROFILE',
  SUBSCRIPTION = 'SUBSCRIPTION',
  STORAGE = 'STORAGE',
  WORKSPACE = 'WORKSPACE',
  TEAM = 'TEAM',
  INVOICING = 'INVOICING',
}
